// extracted by mini-css-extract-plugin
module.exports = {"whereContainer":"WherePage_whereContainer__2Tkh8","label-backgroundcolor":"WherePage_label-backgroundcolor__3-qfb","labelBackgroundcolor":"WherePage_label-backgroundcolor__3-qfb"};